import React, { createContext, useContext, ReactNode } from 'react';
import { useUnifiedQueue } from 'hooks/useUnifiedQueue.ts';

// Define the context type based on the return type of useUnifiedQueue
type QueueContextType = ReturnType<typeof useUnifiedQueue>;

// Create the context
const QueueContext = createContext<QueueContextType | null>(null);

// Provider component
interface QueueProviderProps {
  children: ReactNode;
}

export const QueueProvider: React.FC<QueueProviderProps> = ({ children }) => {
  // Single global instance of the unified queue
  const queueInstance = useUnifiedQueue();

  return (
    <QueueContext.Provider value={queueInstance}>
      {children}
    </QueueContext.Provider>
  );
};

// Custom hook for components to use the queue
export const useQueue = (): QueueContextType => {
  const context = useContext(QueueContext);
  
  if (!context) {
    throw new Error('useQueue must be used within a QueueProvider');
  }
  
  return context;
};

export default QueueContext; 